import { render, staticRenderFns } from "./ClientesClone.vue?vue&type=template&id=5bea2478&"
import script from "./ClientesClone.vue?vue&type=script&lang=js&"
export * from "./ClientesClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports